import React from 'react';
import { Link } from '@naf-simba/elements-links';
import { ArrowDownward } from '@naf-simba/building-blocks-icons/Arrows';
import { useNavigate, useLocation } from 'react-router';
import { useDocumentUrlWithNode } from '@hooks/Documents/useDocumentUrl';
import { RelatedReferenceComponentType } from '@appTypes/articleType';
import { getPromotionEventTrackingData } from '@utils/Tracking/Promotion/getPromotionEventTrackingData';
import { useTrackPromotion } from '@hooks/useTrackPromotion';

interface InternalLinkSerializerProps {
  value: {
    text: string;
    referenceComponent: RelatedReferenceComponentType;
    anchorId?: string;
  };
}

export const InternalLinkBlock = ({ value: { text, anchorId, referenceComponent } }: InternalLinkSerializerProps) => {
  const location = useLocation();

  const referenceUrl = useDocumentUrlWithNode(referenceComponent) || '';
  let linkUrl = referenceUrl;
  if (anchorId) {
    linkUrl = `${referenceUrl}#${anchorId}`;
  }

  const promotion = getPromotionEventTrackingData(text, linkUrl);
  const shouldTrackPromotion = Boolean(promotion);
  const { wrapperRef, trackSelectPromotion } = useTrackPromotion({
    creative_slot: 'internal-link',
    creative_name: `CTA | ${text}`,
    promotion_id: promotion?.promotion_id,
    promotion_name: promotion?.promotion_name,
  });

  const navigate = useNavigate();
  return (
    <div ref={shouldTrackPromotion ? wrapperRef : null}>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action */}
      <Link
        endIcon={location.pathname === referenceUrl && anchorId ? ArrowDownward : undefined}
        onClick={() => {
          if (shouldTrackPromotion) {
            trackSelectPromotion();
          }
          navigate(linkUrl);
        }}
        text={text}
      />
    </div>
  );
};
